export default __webpack_public_path__ + "static/media/icon-entrada.4632908e.svg";